export class ApplicationData {
    #name;
    #version;
    #windowId;
    #paths;
    static #instance;
    constructor(name, windowId, version, paths) {
        this.#name = name;
        this.#windowId = windowId;
        this.#version = version;
        this.#paths = paths;
    }
    static async init() {
        if (this.#instance) {
            throw new Error("Already initialized!");
        }
        const name = await window.api.app.getName();
        const windowId = await window.api.window.getId();
        const version = await window.api.app.getVersion();
        const paths = await window.api.app.getVortexPaths();
        const instance = new ApplicationData(name, windowId, version, paths);
        this.#instance = instance;
        return this.#instance;
    }
    static get instance() {
        if (this.#instance) {
            return this.#instance;
        }
        throw new Error("Not yet initialized!");
    }
    get name() {
        return this.#name;
    }
    get windowId() {
        return this.#windowId;
    }
    get version() {
        return this.#version;
    }
    get paths() {
        return this.#paths;
    }
}
